import React from 'react';
import {
  ISectionProps,
  ITextSection,
  SectionWixFooter,
} from '@wix/shoutout-email-react';
import { WixFooterType } from '@wix/shoutout-email-model-v3';
import { useWixFooterContent } from '@wix/wix-emails-senders';

interface PropTypes extends ISectionProps {
  isRtl: boolean;
  section: ITextSection & { footerType: WixFooterType };
  backgroundColor: string;
  columnCssClass: string;
  cssClass: string;
  experiments: Record<string, string>;
}

export const SectionWixFooterWithContent = (props: PropTypes) => {
  const { getWixFooterContent } = useWixFooterContent();
  const content = getWixFooterContent(props.section.footerType);

  return <SectionWixFooter {...props} content={content} />;
};
